module.exports = __webpack_public_path__ + "static/media/curv-bg.a0283902.svg";